import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppTexts, ScreenNames } from '../objects/app-static-texts';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { FaceLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';

declare global {
  interface Window {
    parentIFrame:any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AppManagementService {
  // DEFAULT HEADER
  apiCallHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      'Access-Control-Allow-Headers': '*'
    })
  };

  faceLandmarker:any;
  runningMode = "IMAGE";

  pageViewEventArray = [];

  back_button_icon:string = "back-arrow.png";
  startScreen:any;
  clientSessionId: any;

  // SCREEN ID TO SENT TO IFRAME
  screen_id:any;

  // Custom Back Button
  customBackButton:any;

  selfie_apiCallHeaders: { headers: HttpHeaders; };

  logged_in_user_email:any;
  previous_screen_name:any;

  current_screen_path: any;

  // Parent Data
  parent_url:any;
  parent_cookie: any;

  // UI APP VERSION
  ui_app_version :any;

  apiURL: null;
  apiType: null;

  quizType: String ="inline";

  backClick: boolean = true;

  // GET CLIENT QUIZ JSON
  client_json_obj:any;

  selectedOptions: any;

  app_load_id:any;
  appPageDesign: any;
  currentPage: any;
  client_config:any;
  isMobile: boolean =false;
  isTablet: boolean =false;
  isDesktop: boolean =false;

  previewQuiz: boolean = false;

  screenHistory = [];

  currentWindow: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    public location: LocationStrategy,
    private googleAnalyticsService: GoogleAnalyticsEventsService) {
    location.onPopState(() => {
      if(this.appPageDesign!=undefined){
        this.setNextPageId(this.appPageDesign.back_page_id);
      }
      if(this.getPageDesign()!=undefined){
        this.router.navigate(["/" + this.getPageDesign().name], { queryParamsHandling: 'preserve' });
        this.scrollToTop();
      }
    });

    this.loadFaceLandMarker();
  }

  scrollToTop(){
    var message = { type: AppTexts.page, key: 'scrollTop', value: '', quiz_type: this.quizType};
    this.sendToIframe(message);
  }

  setQuizType(type){
    this.quizType = type;
  }

  getBackButtonIcon(){
    return this.back_button_icon;
  }

  getBackButtonStyle(){
    var button_classs = ["tangent_back_button_custom"];
    var backbutton_style = this.applyStyles(button_classs);
    return backbutton_style;
  }

  sentHeight(height){
    var message = { type:AppTexts.page, key: 'iframe-height', value: height, quiz_type: this.quizType };
    this.sendToIframe(message);
  }

  // LOADING FIRST SCREEN
  startApp() {
    // FIRST SCREEN NAME
    this.startScreen = this.client_json_obj.config.pages[0];
    this.appPageDesign = this.getAppConfigForKey(this.startScreen);
    this.client_config = this.client_json_obj.config.client;
    if(this.client_json_obj.config.basic.custom_back_button){
      this.back_button_icon = this.client_json_obj.config.basic.custom_back_button;
    }
    this.apiURL = this.client_config.api_url;

    if(this.client_config.api_type!=undefined){
      this.apiType = this.client_config.api_type;
      // SETTING API HEADER TYPES
      switch (this.apiType) {
        case 'hair':
          this.selfie_apiCallHeaders = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': this.client_config.credential_b64
            })
          }
          break;
        default:
          this.selfie_apiCallHeaders = this.apiCallHeaders;
          break;
      }
    }

    // LOAD FONTS
    if(this.client_json_obj.config.fonts!=undefined){
      this.addFontFamily();
    }
  }

  async loadFaceLandMarker(){ 
    const filesetResolver = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm");
    this.faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
            delegate: "GPU"
        },
        outputFaceBlendshapes: true,
        runningMode: "IMAGE",
        numFaces: 1
    });

    // wait for both tasks to complete
    const [result, result2] = await Promise.all([filesetResolver, this.faceLandmarker])
    return { result, result2 }
  }

  getExternalValidations(){
    return this.client_json_obj.config.input_validations;
  }

  // LOAD CUSTOM FONTS THROUGH URL
  addFontFamily() {
    const fontsConfig = this.client_json_obj.config.fonts;

    if (!fontsConfig || fontsConfig.length === 0) {
        console.log("No fonts to load.");
        return;
    }

    const loadFont = (fontName, fontUrl) => {
        const font = new FontFace(fontName, "url("+fontUrl+")");
        return font.load()
            .then(loadedFont => (document as any).fonts.add(loadedFont))
            .catch(error => console.error("Error loading font "+fontName, error));
    };

    if (Array.isArray(fontsConfig)) {
        // Handling clients with a previous JSON design where fonts are in an array
        fontsConfig.forEach(font => {
            const { font_name, font_url } = font;
            loadFont(font_name, font_url);
        });
    } else {
        // Handling primarily case where fonts are defined in a key-value format
        for (let fontName in fontsConfig) {
            if (fontsConfig.hasOwnProperty(fontName)) {
                const fontUrl = fontsConfig[fontName];
                loadFont(fontName, fontUrl);
            }
        }
    }
  }


  getCameraOverlayObject(){
    if(this.client_json_obj.config.basic.camera_overlay!=undefined){
      return this.client_json_obj.config.basic.camera_overlay;
    }
    else{
      return false;
    }
  }

  getApiToServerDataRequests(){
    if(this.client_json_obj.config.basic.api_response_2_server!=undefined){
      return this.client_json_obj.config.basic.api_response_2_server;
    }
    else{
      return false;
    }
  }

  getCameraOverlayText(){
    if(this.client_json_obj.config.basic.camera_overlay.text!=undefined){
      return this.client_json_obj.config.basic.camera_overlay.text;
    }
    else{
      return null;
    }
  }

  getCameraOverlayImg(){
    if(this.client_json_obj.config.basic.camera_overlay.img_url!=undefined){
      return this.client_json_obj.config.basic.camera_overlay.img_url;
    }
    else{
      return null;
    }
  }

  //Setting loaded device type
  setDeviceType(mob, tab, desktop) {
    this.isMobile = mob;
    this.isTablet = tab;
    this.isDesktop = desktop;
  }

  //Fetching style for an Element
  applyElementStyle(element){
    var fullStyle = {};
    var mobStyle = {};
    var tabStyle = {};
    
    if(element!=undefined){
      var commonClassList =[];
      if(element.classes!=undefined){
        commonClassList = element.classes.common;
        
        if(commonClassList!=undefined){
        
          if (commonClassList.length > 0) {
            fullStyle = this.applyStyles(commonClassList);
          }
        
          var idStyle = this.getCSSforID(element.id);
          if (idStyle != undefined) {
            fullStyle = Object.assign(fullStyle, idStyle);
          }
        }
        
        var mobileClassList = [];
        mobileClassList = element.classes.mobile;
        
        if (this.isMobile) {
          if(mobileClassList!=undefined){
            if (mobileClassList.length > 0) {
              mobStyle = this.applyStyles(mobileClassList);
              fullStyle = Object.assign(fullStyle, mobStyle);
            }
          }
        }

        var tabClassList = [];
        if(element.classes.tablet!=undefined){
          tabClassList = element.classes.tablet;
        }
        
        if (this.isTablet) {
          if(tabClassList!=undefined){
            if (tabClassList.length > 0) {
              tabStyle = this.applyStyles(tabClassList);
              fullStyle = Object.assign(fullStyle, tabStyle);
            }
          }
        }
      }
    }
    
    return fullStyle;
  }

  //Fetching styles from list
  applyStyles(classList) {
    var styleC = {};
    if(classList !=undefined){
      if (classList.length > 0) {
        for (var cl = 0; cl < classList.length; cl++) {
          var style = this.getCSSforClass(classList[cl]);
          styleC = Object.assign(styleC, style);
        }
      }
    }
    return styleC;
  }

  setNextPageId(pageId) { this.appPageDesign = this.getAppConfigForKey(pageId); }

  //Enabler for footer with company logo
  enablePoweredBy(){
    return this.client_json_obj.config.basic.enable_poweredBy;
  }

  getSurvey(){
    return this.client_json_obj.config.survey;
  }

  //Initial Call - Fetching JSON for complete app design
  getClientDesignJson(shopId,formId): Observable<Response>{
    this.app_load_id = {
      shop_id:shopId,
      form_id:formId
    };
    // Enable Cache (&cache=false) for dev purpose
    // var localUrl = "https://service.tangent.ai/shopify/get-config?shop_id="+shopId+"&form_id="+formId+"&cache=false";
    var localUrl = "https://service.tangent.ai/shopify/get-config?shop_id="+shopId+"&form_id="+formId;
    return this.http.get<Response>(localUrl);
  }

  getNewSessionId(data): Observable<Response>{
    var localUrl = "https://s.tangent.ai/track?client="+data.client+"&form_id="+data.form_id;
    return this.http.get<Response>(localUrl);
  }

  saveQuizJSON(json) {
    this.client_json_obj = json;
    this.startApp();

    // PRE LOAD IMAGES FROM URL
    const dataString = JSON.stringify(json);
    const imageUrls = dataString.match(/(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/g)
    for (let i = 0; i < imageUrls.length; i++) {
      var img=new Image();
      img.src=imageUrls[i];
    }
  }

  loadPrevious(){
    if (this.screenHistory.length > 0) {
      let previousScreen = this.screenHistory[this.screenHistory.length - 1];
    
      if (this.appPageDesign && previousScreen.name === this.appPageDesign.name) {
        previousScreen = this.screenHistory.pop();
      }
    
      this.sentEventData(AppTexts.clickEventName, AppTexts.ButtonCategory, AppTexts.ClickAction, 'Back', '');
    
      if (previousScreen.type === AppTexts.page) {
        this.setNextPageId(previousScreen.name);
        this.router.navigate(["/" + previousScreen.name], { queryParamsHandling: 'preserve' });
        this.scrollToTop();
        return; // Early return to exit function after navigation
      }
    
      if (this.selectedOptions) {
        if (previousScreen.type === AppTexts.question) {
          this.setNextPageId(ScreenNames.survey);
          this.router.navigate(["/" + ScreenNames.survey], { queryParamsHandling: 'preserve' });
          this.scrollToTop();
        }
      } else {
        this.screenHistory = this.screenHistory.filter(screen => screen.type !== AppTexts.question);
      }
    }
  }

  setPreviewQuizStatus(status){ this.previewQuiz = status; }

  saveSelectedQueries(selected) { this.selectedOptions = selected; }
  
  sentEventData(eventName, eventCategory, eventAction, eventLabel, eventValue) {   
    if (!this.previewQuiz) {
      const eventData = this.setEventDataAndReturn(eventName, eventCategory, eventAction, eventLabel, eventValue);
      this.pageViewEventArray.push({
        type: 'page_event',
        value: eventData
      });
  
      if (this.clientSessionId !== undefined) {
        this.dispatchEventsFromList();
      }
    }
  }

  setEventDataAndReturn(eventName: any, eventCategory: any, eventAction: any, eventLabel: any, eValue: any) {
    // Assign event labels based on event action
    switch (eventAction) {
      case "Selected":
        eventLabel = "Answer Tag";
        break;
      case "Changed":
        eventLabel = "AI Changed";
        break;
    }

    // Process eventLabel and eventAction into finalLabel and finalAction
    const finalLabel = eventLabel.toLowerCase().trim().replace(/ /g, "_");
    const finalAction = eventAction.toLowerCase().trim().replace(/ /g, "_");

    // Handle 'back' action and set eventValue if applicable
    if (finalLabel === "back") {
      let s = this.current_screen_path.substr(0, this.current_screen_path.lastIndexOf("/"));
      if (this.previous_screen_name !== undefined) {
        s += "/"+this.previous_screen_name.name;
        eValue = {
          from: this.current_screen_path,
          to: s
        };
      }
    }
    // Return the view object with details
    return {
      name: eventName,
      category: eventCategory,
      label: finalLabel,
      action: finalAction,
      eventValue: eValue,
      path: this.current_screen_path,
      timeStamp:Date.now()
    };
  }

  dispatchEventsFromList() {
    // Loop to send all events
    while (this.pageViewEventArray.length > 0) {
      const pageViewEvent = this.pageViewEventArray.shift();
      this.sendEventByType(pageViewEvent);
    }
  }
  
  sendEventByType(eventObject: any) {
    // Save event to the server and handle the response
    this.saveEventToServer(eventObject.value.label, eventObject.value.action, eventObject.value.path, eventObject.value)
    .subscribe({
      next: (data) => {
        // Optionally handle success response
      },
      error: (error) => {
        console.error('Error saving event:', error);
      }
    });
    if (eventObject.type === 'page_view') {
      // Send Page title and Path to Google Analytics
      this.googleAnalyticsService.sentToGAView(eventObject.value.view, eventObject.value.path);
    } else {
      // Expected 'page_event' type here
      // Send event to Google Analytics
      this.googleAnalyticsService.eventEmitter(eventObject.value.name, eventObject.value.category, eventObject.value.action, eventObject.value.label);
    }
  }

  
  //UPDATING EVENT DATA TO SERVER
  saveEventToServer(eName, eType, ePath, eValue) : Observable<Response>{
    var session_id = this.getClientSessionId();
    let current_length = ePath.length;
    let final_path = ePath;
    var dataJson;
    if(current_length>99){
      final_path = ePath.substring(0, 99);
    }
    if(session_id!=undefined){
      dataJson = {
        "session_id": session_id,
        "event_type": eType,
        "event_name": eName,
        "page_uri": final_path,
        "event_timestamp": eValue.timeStamp
      }
      if(eValue.eventValue!=undefined && eValue.eventValue!=''){
        dataJson["attributes"] = eValue.eventValue;
      }
    }
    var localUrl = 'https://s.tangent.ai/track';
    var httpOptions = this.getSelfiApiCallHeaders();
    return this.http.post<Response>(localUrl, dataJson, httpOptions);
}
  
  sentSuccessEventToAnalytics(data){
    this.sentEventData(
      AppTexts.clickEventName,
      AppTexts.ButtonCategory,
      "API",
      'Submit Quiz Success',
      {
        resp_id: data['resp_id']
      }
    );
  }

  getNormalSelectClass(qtn){
    var classes= [];

    //ADDING DEFAULT OPTIONS STYLE
    classes = classes.concat(this.client_json_obj.config.basic.normalSelectionClass);

    //IF PARTICULAR SCREEN HAS A STYLE FOR OPTIONS
    if(qtn.style!=undefined){
      if(qtn.style.common!=undefined){
        for(var c=0;c<qtn.style.common.length;c++){
          classes.push(qtn.style.common[c]);
        }
      }
      classes.push(qtn.qID+"_options_custom");
      if(this.isMobile){ 
        if(qtn.style.mobile!=undefined){
          for(var m=0;m<qtn.style.mobile.length;m++){
            classes.push(qtn.style.mobile[m]);
          }
        }
      }
    }
    else{
      classes.push(qtn.qID+"_options_custom");
    }

    if(this.isMobile){
      classes.push(AppTexts.SurveyOptionMobWidth);
      classes.push(AppTexts.SurveyOptionMobCustom);
      classes.push(qtn.qID+"_options_mob_custom");
    }
    return classes;
  }

  getSelectionHighlightCss(qtn){
    var classes= [];

    //ADDING DEFAULT OPTIONS HIGHLIGHT STYLE
    classes = classes.concat(this.client_json_obj.config.basic.highlightedOptionClass);

    //IF PARTICULAR SCREEN HAS A STYLE FOR OPTIONS
    if(qtn.style!=undefined){
      for(var c=0;c<qtn.style.common.length;c++){
        classes.push(qtn.style.common[c]);
      }
      
      //IF HIGHLIGHT IS HAVING PARTICULAR STYLE
      if(qtn.style.highlight!=undefined){
        for(var c=0;c<qtn.style.highlight.length;c++){
          classes.push(qtn.style.highlight[c]);
        }
      }
      classes.push(qtn.qID+"_option_highlight_custom");
      if(this.isMobile){ 
        if(qtn.style.mobile!=undefined){
          for(var m=0;m<qtn.style.mobile.length;m++){
            classes.push(qtn.style.mobile[m]);
          }
        }
      }
    }
    else{
      classes.push(qtn.qID+"_option_highlight_custom");
    }
    
    if(this.isMobile){
      classes.push(AppTexts.SurveyOptionMobWidth);
      classes.push(AppTexts.SurveyOptionMobCustom);
      classes.push(AppTexts.SurveyHighlightOptionMobCustom); 
      classes.push(qtn.qID+"_options_highlight_mob_custom");
    }
    return classes;
  }

  addToScreenHistory(sc_name,sc_type){
    var flag= true;
    if(this.screenHistory.length>0){
      for(var s=0;s<this.screenHistory.length;s++){
        if(this.screenHistory[s]["name"]==sc_name){      
          flag = false;
        }
      }
    }
    if(flag){
      var screen = {
        name: sc_name,
        type: sc_type
      }
      this.screenHistory.push(screen);
    }
  }

  removeFromScreenHistory(screen_name){
    if(this.screenHistory.length>0){
      for (var i=this.screenHistory.length-1; i>=0; i--) {
        if (this.screenHistory[i].name === screen_name) {
          this.screenHistory.splice(i, 1);
          break;
        }
      }
    }
  }

  // SEND DATA TO IFRAM THROUGH POST MESSAGE
  sendToIframe(msg){
    var data = JSON.stringify(msg);
    window.parent.postMessage(data, '*');
  }

  redirectAppToBase() { 
    this.router.navigate(["/"], { queryParamsHandling: 'preserve' });
    this.scrollToTop(); 
  }

  getAppVersion() { return this.ui_app_version; }
  
  getClientSessionId() { return this.clientSessionId; }

  getBackClick() { return this.backClick; }

  setBackClick(click) { this.backClick = click; }

  sentPostMessageToParent(message) { 
    window.parent.postMessage(message, '*'); 
  }

  getAppConfigForKey(key) { return this.client_json_obj[key]; }

  getConfiguratonDisplay(){ return this.client_json_obj.config["visual_report_display"]; }

  getSkinToneMapping(){ return this.client_json_obj.config.skintone_mapping; }

  getPageDesign() { return this.appPageDesign; }

  // GET STYLE USING CLASS NAME
  getCSSforClass(key) { 
    if(this.client_json_obj!=undefined){
      return this.client_json_obj.config.global_css.classes[key]; 
    }
    else{
      return null;
    }
  }
  
  // GET STYLE USING ID NAME
  getCSSforID(id) { return this.client_json_obj.config.global_css.ids[id]; }

  getAppLoadId() { return this.app_load_id; }

  setPreviousScreenName(screen_name) { this.previous_screen_name = screen_name; }

  getSubmitCallbackFunction() { return this.client_json_obj.config.final_submit_callback }

  getRedirectionData() { return this.client_json_obj.config.redirection; }

  getSelfieTagMatcher() { return this.client_json_obj.config.selfie_tag; }

  getClientApiData() { return this.client_json_obj.config.client.api_data_relations; }

  getAIpoweredImg() { return this.client_json_obj.config.basic.AI_powered_img.url; }

  getAIpoweredImgClass() { return this.applyStyles(this.client_json_obj.config.basic.AI_powered_img.class); }

  getCameraDimension() { return this.client_json_obj.config.basic.camera; }

  getServerReqDataFrmSelfie() { return this.client_json_obj.config.client.server_req_selfie_res; }

  getFormInputStyle(key) { return this.client_json_obj.config.global_css.classes[key]; }

  getClientApiType() { return this.apiType; }

  getClientApiURL() { return this.apiURL; }

  getSelfiApiCallHeaders() { return this.selfie_apiCallHeaders; }

  // Remove Last Screen From Screen Flow List
  popFromScreenHistory() { return this.screenHistory.pop(); }

  // Return Screen Flow List in App
  getScreenHistory() { return this.screenHistory; }

  // Return Entire ClientConfig
  getClientConfig() { return this.client_config; }

  getCustomLoader(key) { 
    if(this.client_json_obj.config.basic.loader!=undefined && key!=''){
      return this.client_json_obj.config.basic.loader[key]; 
    }
    else{
      return null;
    }
    
  }

  setLoggedInUserEmail(email){
    this.logged_in_user_email = email;
  }
}